import React, { useContext, memo, useCallback } from "react";
import {
  Marker,
  Polyline,
  InfoBox,
} from "@react-google-maps/api";
import { DownloadModalTypes, MapTools } from "../../../../constants/WebMap";
import { WebMapContext } from "../WebMapGoogleMap";
import { displayArea, displayDistance } from "../../../../helpers/webMap";
import UploadSiteModal from "../../../../components/elements/web-map/tools/siteUploadTool/UploadSiteModal";
import UploadPolygonModal from "../../../../components/elements/web-map/tools/polygonUploadTool/UploadPolygonModal";
import { useEffect } from "react";
import { DownloadPinTool, MapDownloadDataModal } from "../../../../components/elements/web-map/tools";
import DownloadPolygonTool from "../../../../components/elements/web-map/tools/downloadPolygonTool/DownloadPolygonTool";
import { getWebMapSettingFile } from "../../../../services/api/mapFileUpload.api";

const MapToolsSection = ({
  mapTool,
  toolMarkers
}) => {
  const {
    appliedFilters,
    setToolMarkers,
    setMapTool,
    setTriggerFetchUploadedFiles,
    triggerFetchUploadedFiles,
    downloadProperties,
    setDownloadProperties,
  } = useContext(WebMapContext);

  const getPolygonCenter = (latLngs = []) => {
    const bounds = new window.google.maps.LatLngBounds();
    latLngs.forEach((x) => bounds.extend(new window.google.maps.LatLng(x.lat, x.lng)));
    return bounds.getCenter();
  };

  const getWebMapSettings = useCallback(async () => {
    try {
      const response = await getWebMapSettingFile();
      setDownloadProperties({ ...downloadProperties, ...response, radius: 1 });
    } catch (error) {
      console.log(error);
    }
  },[]);

  useEffect(() => {
    if (
      mapTool === MapTools.DOWNLOAD_PIN ||
      mapTool === MapTools.DOWNLOAD_POLYGON || 
      mapTool === MapTools.DOWNLOAD_FROM_FILE
    ) {
      getWebMapSettings();
    }
  }, [getWebMapSettings, mapTool]);
  

  return (
    mapTool && appliedFilters.countryCode ? (
      toolMarkers.length > 0 ? (
        <>
          {toolMarkers?.map((marker, idx) => (
            <Marker
              key={idx}
              position={marker}
              icon={{
                url: "/assets/maptoolmarker.svg",
                scaledSize: new window.google.maps.Size(12, 12),
                anchor: new window.google.maps.Point(6, 7),
              }}
              onClick={() => {
                const temp = [...toolMarkers];
                if ((JSON.stringify(marker) ===
                  JSON.stringify(toolMarkers[0]))) {
                  if (idx != toolMarkers.length - 1
                    && idx != toolMarkers.length - 2)
                    temp.push(marker);
                } else temp.splice(idx, 1);
                setToolMarkers(temp);
              }}
              options={{
                zIndex: 2
              }}
            />
          ))}
          {mapTool === MapTools.DISTANCE ? (
            <>
              <Polyline
                path={toolMarkers}
                options={{
                  strokeWeight: 1.5,
                  strokeColor: "black",
                  strokeOpacity: 0.7,
                  path: toolMarkers,
                  zIndex: 2
                }}
              />
              {toolMarkers.map((marker, idx) => {
                if (idx !== toolMarkers.length - 1) {
                  const origin = new window.google.maps.LatLng(
                    marker.lat,
                    marker.lng
                  );
                  const destination = new window.google.maps.LatLng(
                    toolMarkers[idx + 1].lat,
                    toolMarkers[idx + 1].lng
                  );
                  const distance =
                    window.google.maps.geometry.spherical.computeDistanceBetween(
                      origin,
                      destination
                    );
                  const center =
                    window.google.maps.geometry.spherical.interpolate(
                      origin,
                      destination,
                      0.5
                    );
                  if (distance > 0) {
                    return (
                      <InfoBox
                        position={{
                          lat: center.lat(),
                          lng: center.lng(),
                        }}
                        options={{
                          closeBoxURL: "",
                          enableEventPropagation: true,
                          boxClass: "infoBox-tools",
                          disableAutoPan: true
                        }}
                      >
                        <span>{displayDistance(distance)}</span>
                      </InfoBox>
                    );
                  }
                } else return <></>;
              })}
            </>
          ) : mapTool === MapTools.AREA ? (
            <>
              <Polyline
                path={toolMarkers}
                options={{
                  strokeWeight: 1.5,
                  strokeColor: "black",
                  strokeOpacity: 0.7,
                  path: toolMarkers,
                  zIndex: 2
                }}
              />
              {toolMarkers.length > 2 &&
                (JSON.stringify(toolMarkers[0]) ===
                  JSON.stringify(toolMarkers[toolMarkers.length - 1]))
                ? (
                  <InfoBox
                    position={getPolygonCenter(toolMarkers)}
                    options={{
                      closeBoxURL: "",
                      enableEventPropagation: true,
                      boxClass: "infoBox-tools",
                      disableAutoPan: true,
                      visible: window.google.maps.geometry.spherical.computeArea(
                        toolMarkers
                      ).toFixed(3) > 0
                    }}
                  >
                    <span>
                      {displayArea(window.google.maps.geometry.spherical.computeArea(
                        toolMarkers
                      ))}<sup>2</sup>
                    </span>
                  </InfoBox>
                ) : (
                  <></>
                )}
            </>
          ) : mapTool === MapTools.DOWNLOAD_PIN ? (
            <DownloadPinTool toolMarkers={toolMarkers} />
          ) : mapTool === MapTools.DOWNLOAD_POLYGON ? (
            <DownloadPolygonTool toolMarkers={toolMarkers} />
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
        {mapTool === MapTools.UPLOAD_SITES ? (
          <UploadSiteModal
            isOpen={true}
            onClose={() => setMapTool(null)}
            onConfirm={()=>{
              setMapTool(null);
              setTriggerFetchUploadedFiles(!triggerFetchUploadedFiles);
            }}
          />
        ) : mapTool === MapTools.UPLOAD_POLYGONS ? (
          <UploadPolygonModal
            isOpen={true}
            onClose={() => setMapTool(null)}
            onConfirm={()=>{
              setMapTool(null);
              setTriggerFetchUploadedFiles(!triggerFetchUploadedFiles);
            }}
          />
        ) :mapTool === MapTools.DOWNLOAD_FROM_FILE ? (
          <MapDownloadDataModal
            type={DownloadModalTypes.UPLOAD_FILES}
            isOpen
            onClose={() => setMapTool(null)}
          />
        ): (
          <></>
        )}
      </>
      )
    ) : (
      <></>
    )
  )
};

export default memo(MapToolsSection);